import React from 'react';
import classnames from 'classnames';
import { treeClass } from './styles';
import List from './List';
import { isRTL } from '../config';

function Root(props) {
  var className = classnames(treeClass('_', props.line ? 'with-line' : 'no-line', isRTL() && 'rtl'), props.className);
  return (
    /*#__PURE__*/
    React.createElement(List, Object.assign({}, props, {
      className: className,
      expanded: true,
      path: "",
      isRoot: true,
      deepIndex: 0
    }))
  );
}

Root.defaultProps = {
  data: [],
  line: true
};
export default Root;